export const statusColors: Record<
	string,
	"success" | "danger" | "warning" | "primary" | "default"
> = {
	completed: "success",
	failed: "danger",
	processing: "primary",
	pending: "warning",
	dlq: "danger",
	action_required: "warning",
};

export const statusLocale: Record<string, string> = {
	completed: "Успешно",
	failed: "Ошибка",
	processing: "В процессе",
	pending: "В очереди",
	dlq: "Ошибка",
	action_required: "Требует действия",
};

export const checkTypeLocale: Record<string, string> = {
	connection_check: "Проверка связи",
	full_sync: "Синхронизация",
};

export const conflictTypeLocale: Record<string, string> = {
	data_conflict: "Расхождение данных",
	entity_conflict: "Конфликт сущностей",
	multiple_accounting_matches: "Несколько совпадений в 1С",
	failure: "Сбой синхронизации",
	bidirectional_conflict: "Изменения с обеих сторон",
};

export const conflictTypeColors: Record<
	string,
	"success" | "danger" | "warning" | "primary" | "default"
> = {
	data_conflict: "warning",
	entity_conflict: "danger",
	multiple_accounting_matches: "primary",
	failure: "danger",
	bidirectional_conflict: "warning",
};

export const conflictStatusLocale: Record<string, string> = {
	open: "Открыт",
	resolved: "Разрешён",
};

export const conflictStatusColors: Record<
	string,
	"success" | "danger" | "warning" | "primary" | "default"
> = {
	open: "warning",
	resolved: "success",
};

export const conflictActionLocale: Record<string, string> = {
	accept_elastic: "Принять данные Elastic",
	accept_1c: "Принять данные 1С",
	retry: "Повторить синхронизацию",
	select_accounting_entity: "Связать с выбранной сущностью",
};

export const entityTypeLocale: Record<string, string> = {
	agreement: "Договор",
	business: "Компания",
	renter: "Арендатор",
};

export const syncStageLocale: Record<string, string> = {
	mark_collect: "Сбор изменений",
	existence_check: "Проверка наличия",
	integrity_check: "Проверка целостности",
	sync_push: "Отправка в 1С",
	post_sync_integrity: "Проверка после отправки",
};

export const errorCategoryLocale: Record<string, string> = {
	transient: "Временная",
	validation: "Валидация",
	business_conflict: "Конфликт данных",
	infrastructure: "Инфраструктура",
};

export const errorCategoryColors: Record<
	string,
	"success" | "danger" | "warning" | "primary" | "default"
> = {
	transient: "warning",
	validation: "primary",
	business_conflict: "danger",
	infrastructure: "danger",
};

export const syncErrorCodeLocale: Record<string, string> = {
	http_rate_limited: "1С ограничила частоту запросов",
	http_service_unavailable: "1С недоступна",
	http_timeout: "Таймаут запроса к 1С",
	circuit_open: "Синхронизация приостановлена после серии сбоев",
	conflict_multiple_matches: "В 1С найдено несколько подходящих сущностей",
	conflict_deletion_mark: "Сущность в 1С помечена на удаление",
	conflict_type_mismatch: "Не совпадает тип сущности",
	conflict_inn_ogrn_mismatch: "Не совпадают ИНН/ОГРН",
	bidirectional_conflict: "Данные изменились и в Elastic, и в 1С",
	accounting_changed: "Данные в 1С изменились во время синхронизации",
	missing_required_data: "Не хватает обязательных данных",
	invalid_inn: "Некорректный ИНН",
	invalid_ogrn: "Некорректный ОГРН",
	invalid_kpp: "Некорректный КПП",
	invalid_domain_data: "Некорректные данные в Elastic",
	business_not_found_in_1c: "Компания не найдена в 1С",
	agreement_missing_counterparty: "У договора нет контрагента",
};
